import { GqlRequestOptions } from '@common/api-request';

import { getPdpRecommendGroup } from '../graphql/related-product-recommend-group.2';
import { QueryOptions } from '../lib/queryHelpers';
import { checkValidCatalogProductId } from '../lib/utils';

export const PDP_RELATED_PRODUCT_RECOMMEND_GROUP_QUERY_KEY = 'getRelatedItemList';

export interface GetPdpRelatedProductRecommendGroupParams {
  catalog_product_id: string;
  group_type_list?: string[];
}

export function PdpRelatedProductRecommendGroupQueryOption(
  params: GetPdpRelatedProductRecommendGroupParams,
  options?: GqlRequestOptions,
  queryOptions?: QueryOptions,
) {
  return {
    queryKey: [PDP_RELATED_PRODUCT_RECOMMEND_GROUP_QUERY_KEY],
    queryFn: async function () {
      const { data } = await getPdpRecommendGroup(
        {
          catalog_product_id: params.catalog_product_id,
          group_type_list: params.group_type_list,
        },
        options,
      );
      return data?.related_item_list;
    },
    ...queryOptions,
    enabled: checkValidCatalogProductId(params.catalog_product_id),
  };
}
